import { render, staticRenderFns } from "./IntranetNavContentLink.vue?vue&type=template&id=39226357&scoped=true&"
import script from "./IntranetNavContentLink.vue?vue&type=script&lang=js&"
export * from "./IntranetNavContentLink.vue?vue&type=script&lang=js&"
import style0 from "./IntranetNavContentLink.vue?vue&type=style&index=0&id=39226357&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39226357",
  null
  
)

export default component.exports